var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 28,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M1.1,11.4c0.6-1.3,1.4-2.7,2.5-4.1C4.1,6.6,4.7,6,5.3,5.4 c0.1-0.7,0.2-1.3,0.5-1.9c0.3-0.7,0.8-1.3,1.3-1.7C4.6,3.2,2.5,5.4,1.3,8.1C1,9.1,0.9,10.2,1.1,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M7.5,5.5c0.1,1.9,0.8,4.1,2,6.2c4.6-5,11-7.7,14.9-6 c0.7,0.3,1.3,0.8,1.8,1.4c-1.5-2.6-3.7-4.7-6.5-5.9C16.3,0.3,11.5,2,7.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M8,2.7C7.9,2.9,7.8,3.1,7.8,3.3c2.8-2.1,5.9-3.2,8.4-3.1 c-0.2,0-0.4-0.1-0.6-0.1c-1.9-0.2-3.7,0-5.4,0.4C9.2,1,8.5,1.7,8,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M17.4,26.2c1.8,0.8,5-0.6,7.1-3.2c0.2-0.3,0.4-0.5,0.6-0.8 c-1.9,1.4-5.1,1.3-8.4-0.3C15.8,23.8,16,25.5,17.4,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M24.9,16.9c-1.8-0.8-4.8,0.5-6.8,2.9c3.2,1.6,6.2,1.7,8,0.3 C26.4,18.6,26,17.3,24.9,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M7.3,24.3C7.2,24.3,7.2,24.3,7.3,24.3c0.2,1.3,1.1,2.4,2.4,3 c0,0,0.1,0,0.1,0.1c0.8,0.3,1.7,0.5,2.6,0.6c1.2,0.1,2.3,0.1,3.4,0C13.4,28,10.3,26.8,7.3,24.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M4.8,22c-1.8-2-3.1-4.1-3.9-6.2c-0.2,1.2-0.2,2.4,0,3.4 C2.1,22,4.1,24.4,6.7,26C5.5,25.1,4.9,23.7,4.8,22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M12.8,19.4c-1.3-1-2.4-2.2-3.4-3.4c-1.4,2.1-2.2,4.2-2.4,6.1 c0.5,0.5,1,0.9,1.5,1.3c2.1,1.7,4.2,2.8,6.2,3.4c-1.6-1.1-1.7-3.5-0.3-6.2C13.9,20.3,13.4,19.9,12.8,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M0.4,13.6c-0.1-0.7-0.2-1.4-0.1-2.1c-0.1,0.3-0.1,0.6-0.1,0.9 c-0.1,1.1-0.1,2.2,0,3.3C0.1,15.1,0.2,14.3,0.4,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M27.5,10.2c-0.4-1-1.2-1.8-2.2-2.2c-3.7-1.6-9.9,1-14.2,6 c1,1.3,2.2,2.5,3.5,3.6c0.5,0.4,0.9,0.7,1.4,1c2.8-3.4,7.1-5.3,9.6-4.2c1.6,0.7,2.1,2.5,1.5,4.6c0.1-0.1,0.2-0.3,0.2-0.4 c0.3-0.9,0.5-1.9,0.6-2.9C28.1,13.7,27.9,11.9,27.5,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#FFFFFF"
    },
    d: "M7.8,13.8c-1.3-2.1-2.2-4.2-2.5-6.2c-0.3,0.3-0.6,0.7-0.8,1 c-1.4,1.7-2.3,3.4-3,5c0.7,2.1,1.8,4.2,3.5,6.2C5.4,18,6.3,15.9,7.8,13.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsg);
export default __webpack_public_path__ + "static/media/wsg.198854737ed9e6e3736fec0b679558e1.svg";
export { ForwardRef as ReactComponent };